<adf-dialog-simple-layout>
  <ng-container dialog-header>
    <div class="modal-header alert w-100 m-0 p-3 alert-primary">
      <div class="title h4 m-0 p-0">Create new calculation</div>
      <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
    </div>
  </ng-container>

  <ng-container dialog-content>
    <form [formGroup]="form" class="modal-body d-flex flex-column gap-3">
      <div>
        <label class="form-label" for="project">Project</label>
        <select
          class="form-select"
          formControlName="projectId"
          [class.is-invalid]="f.projectId.invalid && f.projectId.touched"
        >
          <option [ngValue]="null">Select</option>
          @for (project of projects; track project.id) {
            <option [ngValue]="project.id">{{ project.name }}</option>
          }
        </select>
      </div>

      <div>
        <label class="form-label" for="calculation name">Calculation name</label>
        <input
          type="text"
          class="form-control"
          placeholder="Enter"
          formControlName="name"
          [class.is-invalid]="f.name.invalid && f.name.touched"
        />
      </div>

      <div>
        <label class="form-label" for="variant">Variant</label>
        <input type="text" class="form-control" placeholder="Enter" formControlName="variant" />
      </div>

      <div>
        <label class="form-label" for="default currency">Default Currency</label>
        <select
          class="form-select"
          formControlName="defaultCurrencyId"
          [class.is-invalid]="f.defaultCurrencyId.invalid && f.defaultCurrencyId.touched"
        >
          <option [ngValue]="null">Select</option>
          @for (currency of currencies; track currency.id) {
            <option [ngValue]="currency.id">{{ currency.name }}</option>
          }
        </select>
      </div>

      <div>
        <label class="form-label" for="legal entity">Legal Entity</label>
        <select
          class="form-select"
          formControlName="legalEntityId"
          [class.is-invalid]="f.legalEntityId.invalid && f.legalEntityId.touched"
        >
          <option [ngValue]="null">Select</option>
          @for (legalEntity of legalEntities; track legalEntity.id) {
            <option [ngValue]="legalEntity.id">{{ legalEntity.name }}</option>
          }
        </select>
      </div>

      <div>
        <label class="form-label" for="division">Division</label>
        <select
          class="form-select"
          formControlName="divisionId"
          [class.is-invalid]="f.divisionId.invalid && f.divisionId.touched"
        >
          <option [ngValue]="null">Select</option>
          @for (division of filteredDivisions; track division.id) {
            <option [ngValue]="division.id">{{ division.name }}</option>
          }
        </select>
      </div>

      <div>
        <label class="form-label" for="product group">Product Group</label>
        <select
          class="form-select"
          formControlName="productGroupId"
          [class.is-invalid]="f.productGroupId.invalid && f.productGroupId.touched"
        >
          <option [ngValue]="null">Select</option>
          @for (productGroup of filteredProductGroups; track productGroup.id) {
            <option [ngValue]="productGroup.id">{{ productGroup.name }}</option>
          }
        </select>
      </div>

      <div>
        <label class="form-label" for="project type">Project Type</label>
        <select
          class="form-select"
          formControlName="projectTypeId"
          [class.is-invalid]="f.projectTypeId.invalid && f.projectTypeId.touched"
        >
          <option [ngValue]="null">Select</option>
          @for (projectType of projectTypes; track projectType.id) {
            <option [ngValue]="projectType.id">{{ projectType.completeName ?? projectType.lookupValue }}</option>
          }
        </select>
      </div>

      <div>
        <label class="form-label" for="eu type">EU Type</label>
        <select
          class="form-select"
          formControlName="euTypeId"
          [class.is-invalid]="f.euTypeId.invalid && f.euTypeId.touched"
        >
          <option [ngValue]="null">Select</option>
          @for (euType of euTypes; track euType.id) {
            <option [ngValue]="euType.id">{{ euType.completeName ?? euType.lookupValue }}</option>
          }
        </select>
      </div>

      <div>
        <label class="form-label" for="importDataLabel">Import data from existing file (Optional)</label>
        <div class="file-drop-zone-container position-relative">
          <input #fileInput type="file" hidden (change)="onFileSelected($event)" />
          <button
            type="button"
            class="file-drop-zone w-100 bg-transparent"
            [class.drag-over]="isDragOver"
            aria-labelledby="importDataLabel"
            (click)="fileInput.click()"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onFileDropped($event)"
          >
            @if (selectedFile) {
              <div class="d-flex align-items-center gap-2">
                <i class="bi bi-file-earmark-check fs-4"></i>
                <span>{{ selectedFile.name }}</span>
              </div>
            } @else {
              <i class="bi bi-cloud-arrow-up fs-2"></i>
              <div class="text-center">
                <div>Click or drag file to this area to upload</div>
                <small class="text-muted">Support for a single or bulk upload. Maximum file size 2MB.</small>
              </div>
            }
          </button>
          @if (selectedFile) {
            <button
              type="button"
              class="btn-close file-drop-zone-remove"
              aria-label="Remove file"
              (click)="clearSelectedFile($event)"
            ></button>
          }
        </div>
        @if (fileError) {
          <div class="text-danger small mt-1">{{ fileError }}</div>
        }
      </div>
    </form>
  </ng-container>

  <ng-container dialog-footer>
    <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Cancel</button>
    <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="onFinish()">
      <i class="bi bi-check2"></i> Finish
    </button>
  </ng-container>
</adf-dialog-simple-layout>
